import React, { useState } from "react";
import { useMeterReadingFormat } from "../../../hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { TableColumn } from "@shared/types/table";
import { GenericTable } from "@shared/components/GenericTable";
import { EyeIcon, PenBox, Pencil, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getStatusBadgeClass } from "@shared/utils/statusUtils";
import { PageHeader } from "@shared/ui/pageHeader";
import { Button } from "@shared/ui/button";

export function ReadFormatTab() {
  const navigate = useNavigate();
  const remoteUtilityId = useRemoteUtilityId();
  const [search, setSearch] = useState<string>("");
  const { data: meterFormat, isLoading } = useMeterReadingFormat(
    remoteUtilityId,
    search,
  );

  const templateHeaders: TableColumn[] = [
    {
      key: "name",
      header: "Format name",
      sortable: false,
    },
    {
      key: "totalFields",
      header: "Total Fields",
      sortable: false,
    },
    {
      key: "dataCollectionMethod",
      header: "Data Collection Method",
      render: (row: any) => {
        return (
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusBadgeClass(
              row?.name,
            )}`}
          >
            {row?.name}
          </span>
        );
      },
    },
    {
      key: "utilityService",
      header: "Utility Service",
      sortable: false,
    },
    {
      key: "status",
      header: "Status",
      sortable: false,
      render: (row: any) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusBadgeClass(
            row,
          )}`}
        >
          {row}
        </span>
      ),
    },
    {
      key: "createdDate",
      header: "Created On",
      sortable: false,
    },
    {
      key: "createdUserRemoteName",
      header: "Created By",
      sortable: false,
    },
  ];

  const actions = [
    {
      label: "View",
      icon: <EyeIcon className="h-5 w-5" />,
      onClick: (row: any) => {
        navigate(`/mx/settings/meterread-format/view/${row.id}`);
      },
    },
    {
      label: "Edit",
      icon: <Pencil className="h-5 w-5" />,
      onClick: (row: any) => {
        navigate(`/mx/settings/meterread-format/edit/${row.id}`);
      },
    },
  ];

  const pagination = {
    currentPage: 1,
    totalPages: 1,
    totalItems: meterFormat?.length || 0,
    itemsPerPage: meterFormat?.length || 10,
    startItem: 1,
    endItem: meterFormat?.length || 0,
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <PageHeader
          title="Meter Read Formats"
          description="Manage all your meter reading formats"
        />
        <Button
          onClick={() => {
            navigate("/mx/settings/meterread-format/add");
          }}
          className="bg-primary text-white"
        >
          <Plus className="w-4 h-4 mr-2" /> Create New Format
        </Button>
      </div>
      <GenericTable
        rowKey="id"
        columns={templateHeaders}
        data={meterFormat}
        loading={isLoading}
        actions={actions}
        actionsType="icons"
        emptyMessage="No templates available"
        pagination={pagination}
        onPageChange={() => {}} // No-op since pagination is static
        onSearch={(search) => setSearch(search)}
        searchPlaceholder="Search templates..."
      />
    </div>
  );
}
export default ReadFormatTab;
